module.exports = "/assets/data/9b28cdeec70dd757691d3915fc51687b-DA2.data.json";